// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/slider/style/index.less
// module id = 960
// module chunks = 1